var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip.top-center",value:(_vm.hoverText),expression:"hoverText",modifiers:{"top-center":true}}],class:_vm.clazz,on:{"click":function($event){$event.stopPropagation();return _vm.$emit('onClick', _vm.tid)}}},[_vm._v(" "+_vm._s(_vm.badgeText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }